<template>
    <component :is="cardElement" :title="cardTitle" :class="cardClass" :icon="cardIcon" :header-color="cardColor"
        v-show="!editDisabled || !emptyState"
        :actions="card_actions" actions-color="dark" :bus="bus">

        <!-- Competencies view -->

        <enac-atpl-dashboard-flight-follow-up-edit-competencies-view :parent-id="id" :id="id+'-competencies'" :bus="bus" 
            :states="states" :indicators="indicators" :edit-disabled="editDisabled" :mandatory-competencies="item.meta.competencies">
        </enac-atpl-dashboard-flight-follow-up-edit-competencies-view>
        
        <!-- Competencies modal -->

        <trax-ui-modal-plain-header :id="id+'-competencies-select'" :bus="bus" size="lg" v-if="!editDisabled">
            <enac-atpl-dashboard-level-report-edit-competencies-select :id="id+'-competencies-select'" :bus="bus">
            </enac-atpl-dashboard-level-report-edit-competencies-select>
        </trax-ui-modal-plain-header>

    </component>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-level-report-learner-edit'},
            source: {default: '3'},
            target: {default: '4'},
            editDisabled: null,
            cardElement: {default: 'trax-ui-card'},
            cardTitle: {default: lang.polaris.training.competencies},
            cardClass: {default: 'mt-3'},
            cardIcon: null,
            cardColor: null
        },

        data: function() {
            return {
                lang: lang,
                item: data.item,
                states: {},
                indicators: {},
                endpoint: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/learning-units/'+data.item.id+'/learners/'+data.learner.id,
                bus: this.$bus
            }
        },

        computed: {

            card_actions() {
                if (this.editDisabled) {
                    return [
                        { icon: 'keyboard_arrow_down', event: this.id + '-expand-competencies' },
                        { icon: 'keyboard_arrow_up', event: this.id + '-collapse-competencies' }
                    ];
                }
            },

            emptyState() {
                for(var key in this.states) {
                    var state = this.states[key];
                    if (state.level || state.comments || (state.indicators && state.indicators.length)) return false;
                }
                return true;            
            }
        },

        created: function() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-competencies-select-set', this.setSelect);
            if (this.editDisabled) this.loadStates();
        },

        methods: {

            loadStates() {
                var that = this;
                axios.get(this.endpoint)
                    .then(function (response) {
                        response.data.data.included = response.data.included
                        that.bus.$emit(that.id+'-states-data', response.data.data);
                        that.setStates(response.data.data);
                    })
            },

            setStates(states) {
                if (!states.competencies) {
                    this.indicators = {};
                    this.states = {};
                    return;
                }

                this.indicators = states.included.indicators instanceof Array
                    ? {}
                    : states.included.indicators;

                this.states = states.competencies.data instanceof Array
                    ? {}
                    : states.competencies.data;

                for (var id in states.competencies.data) {
                    states.competencies.data[id].indicators = states.competencies.data[id].indicators instanceof Array
                        ? {}
                        : states.competencies.data[id].indicators;
                }
            },

            setSelect(data) {
                this.states[data.type_code] = data.states;
                for (var id in data.indicators) this.indicators[id] = data.indicators[id]; 
                this.bus.$emit(this.id+'-competencies-view-force-update');
            },

            saveData(data) {
                data.competencies = this.states;
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            }
        },
    }
</script>
